import script from "./MsButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./MsButton.vue?vue&type=script&setup=true&lang=ts"

import "./MsButton.vue?vue&type=style&index=0&id=4543796d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4543796d"]])

export default __exports__